import * as React from "react";
import C from "classnames";
const sizeMapper = {
    sm: "breadcrumb-sm",
};
export const Breadcrumb = ({ children, className, testid, size, padding, }) => {
    return (React.createElement("nav", { "aria-label": "breadcrumb" },
        React.createElement("ol", { "data-testid": testid, className: C(className, "breadcrumb", size && sizeMapper[size], !padding && "p-0") }, children)));
};
//# sourceMappingURL=Breadcrumb.js.map